export default __webpack_public_path__ + "static/icon-35-1-15d0bc2df7162380a20cac4de1986a40.png";